// 基准字体大小
const baseSize = 16
// 设计稿宽度
const designWidth = 1920

function setRem() {
  // 当前页面宽度相对于设计稿宽度的缩放比例
  const scale = document.documentElement.clientWidth / designWidth
  // 设置页面根节点字体大小（最小为12px，最大为24px）
  const fontSize = Math.min(Math.max(baseSize * scale, 12), 24)
  document.documentElement.style.fontSize = `${fontSize}px`
}

// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.addEventListener('resize', setRem)
